import React, { Component } from 'react'
import { Row, Col, Button, Icon, Divider, Table, message, Modal } from 'antd'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';

import { getCookie } from './../../hook';

// Actions
import { get_travel_requests, delete_travel_requests } from './actions/travel.action'

// Styles
import './style.css'

// Children
import NewTravel from './childs/new.travel'
const { confirm } = Modal;

class Travel extends Component {

    constructor( props ){
        super( props );

        this.state = { 
            travel_data: [],
            visible: false,
        }

        this.handleVisibleChange = this.handleVisibleChange.bind( this );
        this.handleCancelModal = this.handleCancelModal.bind( this );
        this.handleTravelDelete = this.handleTravelDelete.bind( this );
        this.handleTravelEdit = this.handleTravelEdit.bind( this );
        this.handleTravelPrint = this.handleTravelPrint.bind( this );

    }

    handleTravelPrint( id ){
        this.props.history.push( '/prints/travel/'+ id );
    }

    handleTravelEdit( id ){
        this.props.history.push( '/travel/edit/'+ id );
    }

    handleTravelDelete( travel_id ){
        let self = this;
        
        confirm({
            title: 'Do you Want to delete these item?',
            onOk() {
                self.props.delete_travel_requests( travel_id );
            },
            onCancel() {
                //
            },
        });

    }

    handleCancelModal(){
        this.setState({ visible: false });
    }

    handleVisibleChange(){
        this.setState({ visible: true });
    }

    componentWillMount(){
        let user = getCookie('dv_hrms_user').split(',');
        this.props.get_travel_requests( user[6] );
    }

    componentWillReceiveProps( nextProps ){
        if( nextProps.travel.length !== 0 ){

            if( nextProps.travel.STATUS.CODE === '200' &&
                nextProps.travel.STATUS.MESSAGE === 'Successfully travel Listed' ){
                this.setState({
                    travel_data: nextProps.travel.OUTPUT.DATA
                });
            }

            if( nextProps.travel.STATUS.CODE === '400' ){
                message.error( nextProps.travel.STATUS.MESSAGE );
            }

            if( nextProps.travel.STATUS.CODE === '200' &&
                nextProps.travel.STATUS.MESSAGE === 'Successfully Delete travel' ){
                let user = getCookie('dv_hrms_user').split(',');
                this.props.get_travel_requests( user[6] );
            }
            
        }
    }

    render() {

        const travel_column = [
            {
                title: 'SLNo#',
                dataIndex: 'key',
                key: 'key',
                width: '2%'
            },
            {
                title: 'User Name',
                dataIndex: 'full_name',
                key: 'full_name',
                width: '20%'
            },
            {
                title: 'Remarks',
                dataIndex: 'remarks',
                key: 'remarks',
                width: '50%'
            },
            {
                title: 'Action',
                width: '28%',
                render: (data) => <span>
                    <Button
                        onClick={ (e)=> this.handleTravelEdit( data.travel_id ) }
                        type="primary" size="small" icon="edit">Edit</Button>&nbsp;
                    <Button
                        onClick={ (e)=> this.handleTravelPrint( data.travel_id ) }
                        type="primary" size="small" icon="edit">Print</Button>&nbsp;
                    <Button
                        onClick={ (e)=> this.handleTravelDelete( data.travel_id ) }
                        type="danger" size="small" icon="delete">Delete</Button>
                </span>
            }
        ];

        const destination_column = [
            {
                title: 'Departure Location',
                dataIndex: 'departure_location',
                key: 'departure_location',
            },{
                title: 'Departure Date',
                dataIndex: 'departure_date',
                key: 'departure_date',
            },{
                title: 'Departure Time',
                dataIndex: 'departure_time',
                key: 'departure_time',
            },{
                title: 'Arrival Location',
                dataIndex: 'arrival_location',
                key: 'arrival_location',
            },{
                title: 'Arrival Date',
                dataIndex: 'arrival_date',
                key: 'arrival_date',
            },{
                title: 'Arrival Time',
                dataIndex: 'arrival_time',
                key: 'arrival_time',
            }
        ];

        const hotel_column = [
            {
                title: 'Hotel Location',
                dataIndex: 'hotel_location',
                key: 'hotel_location',
            },{
                title: 'Check In',
                dataIndex: 'hotel_check_in',
                key: 'hotel_check_in',
            },{
                title: 'Check Out',
                dataIndex: 'hotel_check_out',
                key: 'hotel_check_out',
            }
        ]

        return (
            <div className="travel_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="tag" />
                            &nbsp; Travel Requisition
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Link to={ '/travel/new/' }>
                            <Button className="fl_right" type="primary" icon="plus">Add New Request</Button>
                        </Link>
                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <Table
                            expandedRowRender={record => <div>
                                <h3>Destinations</h3>
                                <Table size="small" pagination={false} dataSource={ record.destinations } columns={ destination_column } />
                                <h3 className="mrg_t_20">Hotels</h3>
                                <Table size="small" pagination={false} dataSource={ record.hotels } columns={ hotel_column } />
                            </div>}
                            columns={ travel_column } dataSource={ this.state.travel_data } />
                    </Col>
                </Row>

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        travel: state.travel
    }
}

export default connect( mapStatetoProps, { get_travel_requests, delete_travel_requests })( Travel );


// WEBPACK FOOTER //
// ./src/pages/travel/index.js